import React from 'react';
export const Footer = () => {
  return <footer className="w-full bg-blue-900 text-white py-6 mt-8" data-id="element-125">
      <div className="container mx-auto px-4 text-center text-sm" data-id="element-126">
        <p className="mb-2" data-id="element-127">
          Individual results may vary. This product is not intended to diagnose,
          treat, cure, or prevent any disease. Consult your physician before
          making any health-related decisions.
        </p>
        <p className="mb-2" data-id="element-128">
          © {new Date().getFullYear()} Veloura. All Rights Reserved.
        </p>
        <div className="flex justify-center space-x-4 mt-4" data-id="element-129">
          <a href="#" className="hover:underline" data-id="element-130">
            Privacy Policy
          </a>
          <a href="#" className="hover:underline" data-id="element-131">
            Terms of Service
          </a>
          <a href="#" className="hover:underline" data-id="element-132">
            Contact Us
          </a>
        </div>
      </div>
    </footer>;
};